interface HostConfig {
  monolithApi: string;
  loginApi: string;
  fileServiceApi: string;
  reportServiceApi: string;
  bulkDomain: string;
}
export const hostConfig = window['hostConfig'] as HostConfig;
